import { render, staticRenderFns } from "./editText.vue?vue&type=template&id=0065392c&scoped=true&"
import script from "./editText.vue?vue&type=script&lang=js&"
export * from "./editText.vue?vue&type=script&lang=js&"
import style0 from "./editText.vue?vue&type=style&index=0&id=0065392c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065392c",
  null
  
)

export default component.exports